import { EcommerceTrackingData } from "./ecommerce-tracking-data.class";
export class ViewEcommerceTrackingData extends EcommerceTrackingData {
    productId;
    listPageType;
    listEntityType;
    listName;
    organisationId;
    disciplines;
    premium;
    listPosition;
    unitPrice;
    currency;
    productType;
    constructor(productId, listPageType, listEntityType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency, productType) {
        super(productId, listPageType, listName, organisationId, disciplines, premium, listPosition, unitPrice, currency);
        this.productId = productId;
        this.listPageType = listPageType;
        this.listEntityType = listEntityType;
        this.listName = listName;
        this.organisationId = organisationId;
        this.disciplines = disciplines;
        this.premium = premium;
        this.listPosition = listPosition;
        this.unitPrice = unitPrice;
        this.currency = currency;
        this.productType = productType;
    }
    getTrackingContext() {
        return {
            organisationId: this.getOrganisationId(),
            studyId: this.getProductId(),
            scholarshipId: undefined,
            bodyId: undefined,
            premiumnessLevel: this.premium?.toString() ?? '',
            price: undefined,
            position: this.listPosition,
            currency: this.getCurrency()
        };
    }
}
